import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'edumono-detail-item',
  templateUrl: './detail-item.component.html',
  styleUrls: ['./detail-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DetailItemComponent implements OnInit {
  @Input() content: string;
  @Input() image: string;
  @Input() property: string;
  constructor() {}

  ngOnInit(): void {}
}
